import palette from "../../theme/palette"

const themePalette = palette("light")

export const presets = [
    {
        name: "default",
        ...themePalette.primary
    },
    {
        name: "cyan",
        lighter: "#CCF4FE",
        light: "#68CDF9",
        main: "#078DEE",
        dark: "#0351AB",
        darker: "#012972",
        contrastText: "#FFFFFF"
    },
    {
        name: "purple",
        lighter: "#EBD6FD",
        light: "#B985F4",
        main: "#7635dc",
        dark: "#431A9E",
        darker: "#200A69",
        contrastText: "#FFFFFF"
    },
    {
        name: "blue",
        lighter: "#D1E9FC",
        light: "#76B0F1",
        main: "#2065D1",
        dark: "#103996",
        darker: "#061B64",
        contrastText: "#FFFFFF"
    },
    {
        name: "orange",
        lighter: "#FEF4D4",
        light: "#FED680",
        main: "#fda92d",
        dark: "#B66816",
        darker: "#793908",
        contrastText: themePalette.grey[800]
    },
    {
        name: "red",
        lighter: "#FFE3D5",
        light: "#FFC1AC",
        main: "#FF3030",
        dark: "#B71833",
        darker: "#7A0930",
        contrastText: "#FFFFFF"
    }
]

export const presetsCompany = {
    default: {
        name: "default",
        ...themePalette.primary
    },
    libertad: {
        name: "libertad",
        lighter: "#CCF4FE",
        light: "#68CDF9",
        main: "#078DEE",
        dark: "#0351AB",
        darker: "#012972",
        contrastText: "#FFFFFF"
    },
    bahia: {
        name: "bahia",
        lighter: "#C7F9E2",
        light: "#59DFBA",
        main: "#009688",
        dark: "#00626C",
        darker: "#003448",
        contrastText: "#FFFFFF"
    },
    ilosur: {
        name: "ilosur",
        lighter: "#FFF1CC",
        light: "#FFC966",
        main: "#FF8F00",
        dark: "#B75600",
        darker: "#7A2E00",
        contrastText: themePalette.grey[800]
    },
    ruta22: {
        name: "ruta22",
        lighter: "#b1ded2",
        light: "#4eb498",
        main: "#039371",
        dark: "#00664a",
        darker: "#004b2f",
        contrastText: "#FFFFFF"
    },
    mayo20: {
        name: "20mayo",
        lighter: "#ff6666",
        light: "#ff3333",
        main: "#ff1212",
        dark: "#cc0000",
        darker: "#990000",
        contrastText: "#FFFFFF"
    }
}

const companyName = process.env.REACT_APP_MAIN_COLOR
export const defaultPreset = presetsCompany[companyName]
export const cyanPreset = presets[1]
export const purplePreset = presets[2]
export const bluePreset = presets[3]
export const orangePreset = presets[4]
export const redPreset = presets[5]

export const presetsOption = presets.map((color) => ({
    name: color.name,
    value: color.main
}))

export function getPresets(key) {
    return {
        default: defaultPreset,
        cyan: cyanPreset,
        purple: purplePreset,
        blue: bluePreset,
        orange: orangePreset,
        red: redPreset
    }[key]
}